__turbopack_context__.v({
  "about": "EBBLandingPageSimple-module__gACdXa__about",
  "aboutBlock": "EBBLandingPageSimple-module__gACdXa__aboutBlock",
  "aboutCopy": "EBBLandingPageSimple-module__gACdXa__aboutCopy",
  "aboutCta": "EBBLandingPageSimple-module__gACdXa__aboutCta",
  "accent": "EBBLandingPageSimple-module__gACdXa__accent",
  "band": "EBBLandingPageSimple-module__gACdXa__band",
  "closing": "EBBLandingPageSimple-module__gACdXa__closing",
  "closingBanner": "EBBLandingPageSimple-module__gACdXa__closingBanner",
  "closingEm": "EBBLandingPageSimple-module__gACdXa__closingEm",
  "devicesImage": "EBBLandingPageSimple-module__gACdXa__devicesImage",
  "hasMosaic": "EBBLandingPageSimple-module__gACdXa__hasMosaic",
  "hero": "EBBLandingPageSimple-module__gACdXa__hero",
  "heroBleed": "EBBLandingPageSimple-module__gACdXa__heroBleed",
  "heroCopy": "EBBLandingPageSimple-module__gACdXa__heroCopy",
  "heroDevices": "EBBLandingPageSimple-module__gACdXa__heroDevices",
  "heroEm": "EBBLandingPageSimple-module__gACdXa__heroEm",
  "heroLine": "EBBLandingPageSimple-module__gACdXa__heroLine",
  "heroSub": "EBBLandingPageSimple-module__gACdXa__heroSub",
  "mosaic": "EBBLandingPageSimple-module__gACdXa__mosaic",
  "mosaicImage": "EBBLandingPageSimple-module__gACdXa__mosaicImage",
  "page": "EBBLandingPageSimple-module__gACdXa__page",
  "testimonialCard": "EBBLandingPageSimple-module__gACdXa__testimonialCard",
  "testimonials": "EBBLandingPageSimple-module__gACdXa__testimonials",
  "testimonialsDesktop": "EBBLandingPageSimple-module__gACdXa__testimonialsDesktop",
  "testimonialsMobile": "EBBLandingPageSimple-module__gACdXa__testimonialsMobile",
});
